import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_4e55e184 from 'nuxt_plugin_sentryserver_4e55e184' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_731b9db6 from 'nuxt_plugin_sentryclient_731b9db6' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_authenticate_48c0c5ae from 'nuxt_plugin_authenticate_48c0c5ae' // Source: ./authenticate.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_0f3ad522 from 'nuxt_plugin_cookieuniversalnuxt_0f3ad522' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtenv_699d599b from 'nuxt_plugin_nuxtenv_699d599b' // Source: ./nuxt-env.js (mode: 'all')
import nuxt_plugin_libmoduleplugin3e533dd4_56bfcd6a from 'nuxt_plugin_libmoduleplugin3e533dd4_56bfcd6a' // Source: ./lib.module.plugin.3e533dd4.js (mode: 'all')
import nuxt_plugin_axios_49812d0c from 'nuxt_plugin_axios_49812d0c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_412046d0 from 'nuxt_plugin_gtm_412046d0' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_injectsessionclient_81c33da4 from 'nuxt_plugin_injectsessionclient_81c33da4' // Source: ../plugins/inject-session.client.js (mode: 'client')
import nuxt_plugin_vuetoastr_07f02570 from 'nuxt_plugin_vuetoastr_07f02570' // Source: ../plugins/vue-toastr (mode: 'client')
import nuxt_plugin_pagination_509610e0 from 'nuxt_plugin_pagination_509610e0' // Source: ../plugins/pagination (mode: 'all')
import nuxt_plugin_cachios_070227b4 from 'nuxt_plugin_cachios_070227b4' // Source: ../plugins/cachios (mode: 'all')
import nuxt_plugin_fontawesome_47952b5b from 'nuxt_plugin_fontawesome_47952b5b' // Source: ../plugins/font-awesome (mode: 'all')
import nuxt_plugin_vue2filters_60d05d10 from 'nuxt_plugin_vue2filters_60d05d10' // Source: ../plugins/vue2-filters (mode: 'all')
import nuxt_plugin_vuejspopover_94d94484 from 'nuxt_plugin_vuejspopover_94d94484' // Source: ../plugins/vue-js-popover (mode: 'client')
import nuxt_plugin_captureutmparams_4a8a6562 from 'nuxt_plugin_captureutmparams_4a8a6562' // Source: ../plugins/capture-utm-params (mode: 'client')
import nuxt_plugin_activity_df398ef6 from 'nuxt_plugin_activity_df398ef6' // Source: ../plugins/activity (mode: 'all')
import nuxt_plugin_experiments_236de2e0 from 'nuxt_plugin_experiments_236de2e0' // Source: ../plugins/experiments (mode: 'all')
import nuxt_plugin_impressions_c0042358 from 'nuxt_plugin_impressions_c0042358' // Source: ../plugins/impressions (mode: 'all')
import nuxt_plugin_whitelistlinks_9c204706 from 'nuxt_plugin_whitelistlinks_9c204706' // Source: ../plugins/whitelist-links (mode: 'client')
import nuxt_plugin_gtmspa_090d317e from 'nuxt_plugin_gtmspa_090d317e' // Source: ../plugins/gtm-spa (mode: 'client')
import nuxt_plugin_gtag_6a810249 from 'nuxt_plugin_gtag_6a810249' // Source: ../plugins/gtag (mode: 'client')
import nuxt_plugin_viewportwidth_e68859fc from 'nuxt_plugin_viewportwidth_e68859fc' // Source: ../plugins/viewport-width.js (mode: 'client')
import nuxt_plugin_stripeelements_1d901216 from 'nuxt_plugin_stripeelements_1d901216' // Source: ../plugins/stripe-elements.js (mode: 'client')
import nuxt_plugin_vuepluginloadscript_d0eeb17c from 'nuxt_plugin_vuepluginloadscript_d0eeb17c' // Source: ../plugins/vue-plugin-load-script.js (mode: 'all')
import nuxt_plugin_plugin_3ad0b605 from 'nuxt_plugin_plugin_3ad0b605' // Source: ../node_modules/@appsumo/inject-session-plugin/templates/plugin.js (mode: 'server')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"AppSumo","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"AppSumo"},{"name":"p:domain_verify","content":"f56ac577edc559827a3f367c1e44b381"}],"link":[],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-K87H2BB&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_4e55e184 === 'function') {
    await nuxt_plugin_sentryserver_4e55e184(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_731b9db6 === 'function') {
    await nuxt_plugin_sentryclient_731b9db6(app.context, inject)
  }

  if (typeof nuxt_plugin_authenticate_48c0c5ae === 'function') {
    await nuxt_plugin_authenticate_48c0c5ae(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_0f3ad522 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_0f3ad522(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtenv_699d599b === 'function') {
    await nuxt_plugin_nuxtenv_699d599b(app.context, inject)
  }

  if (typeof nuxt_plugin_libmoduleplugin3e533dd4_56bfcd6a === 'function') {
    await nuxt_plugin_libmoduleplugin3e533dd4_56bfcd6a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_49812d0c === 'function') {
    await nuxt_plugin_axios_49812d0c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_412046d0 === 'function') {
    await nuxt_plugin_gtm_412046d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_injectsessionclient_81c33da4 === 'function') {
    await nuxt_plugin_injectsessionclient_81c33da4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetoastr_07f02570 === 'function') {
    await nuxt_plugin_vuetoastr_07f02570(app.context, inject)
  }

  if (typeof nuxt_plugin_pagination_509610e0 === 'function') {
    await nuxt_plugin_pagination_509610e0(app.context, inject)
  }

  if (typeof nuxt_plugin_cachios_070227b4 === 'function') {
    await nuxt_plugin_cachios_070227b4(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_47952b5b === 'function') {
    await nuxt_plugin_fontawesome_47952b5b(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2filters_60d05d10 === 'function') {
    await nuxt_plugin_vue2filters_60d05d10(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejspopover_94d94484 === 'function') {
    await nuxt_plugin_vuejspopover_94d94484(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_captureutmparams_4a8a6562 === 'function') {
    await nuxt_plugin_captureutmparams_4a8a6562(app.context, inject)
  }

  if (typeof nuxt_plugin_activity_df398ef6 === 'function') {
    await nuxt_plugin_activity_df398ef6(app.context, inject)
  }

  if (typeof nuxt_plugin_experiments_236de2e0 === 'function') {
    await nuxt_plugin_experiments_236de2e0(app.context, inject)
  }

  if (typeof nuxt_plugin_impressions_c0042358 === 'function') {
    await nuxt_plugin_impressions_c0042358(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_whitelistlinks_9c204706 === 'function') {
    await nuxt_plugin_whitelistlinks_9c204706(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmspa_090d317e === 'function') {
    await nuxt_plugin_gtmspa_090d317e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_6a810249 === 'function') {
    await nuxt_plugin_gtag_6a810249(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_viewportwidth_e68859fc === 'function') {
    await nuxt_plugin_viewportwidth_e68859fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_stripeelements_1d901216 === 'function') {
    await nuxt_plugin_stripeelements_1d901216(app.context, inject)
  }

  if (typeof nuxt_plugin_vuepluginloadscript_d0eeb17c === 'function') {
    await nuxt_plugin_vuepluginloadscript_d0eeb17c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin_3ad0b605 === 'function') {
    await nuxt_plugin_plugin_3ad0b605(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
